import React from 'react';
import { PeoplePanel } from '../controls/People/PeoplePanel';
import { ArcaComponent } from './ArcaComponent';

export class AdminList extends ArcaComponent {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <PeoplePanel type='Admin' />
        );
    }
}